import React from "react";
import "./dropdown-field.css";

export default function DropdownField({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = "Select...",
  required = false,
  disabled = false,
  className = "",
}) {
  return (
    <div className={`dropdown-field ${className}`}>
      {label && (
        <label className="dropdown-label" htmlFor={name}>
          {label} {required && <span className="dropdown-required">*</span>}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className="dropdown-select"
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option 
            key={option.value} 
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
